// Module
var code = "<div class=\"fatal-errors-containers\"> <div class=\"fatal-content\"> <div class=\"header\"> Please report the following to Adviser Services team to resolve </div> <div class=\"body-errors\" ng-repeat=\"error in $ctrl.fatalErrorsData track by $index\"> <span> {{error}} </span> </div> </div> </div> ";
// Exports
module.exports = code;